// Generated by purs version 0.15.0
import * as Data_DateTime_Instant from "../Data.DateTime.Instant/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Time_Duration from "../Data.Time.Duration/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Class_Console from "../Effect.Class.Console/index.js";
import * as Effect_Now from "../Effect.Now/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Cart_State_State from "../Restaumatic.Cart.State.State/index.js";
import * as Restaumatic_Services_Storage from "../Restaumatic.Services.Storage/index.js";
import * as Restaumatic_Services_Storage_LocalStorageNoFallback from "../Restaumatic.Services.Storage.LocalStorageNoFallback/index.js";
import * as Restaumatic_Services_Storage_LocalStorageWithFallback from "../Restaumatic.Services.Storage.LocalStorageWithFallback/index.js";
var previousOrderKey = "previousOrder";
var nowMilliseconds = /* #__PURE__ */ Effect_Class.liftEffect(Effect_Class.monadEffectEffect)(/* #__PURE__ */ Data_Functor.map(Effect.functorEffect)(Data_DateTime_Instant.unInstant)(Effect_Now.now));
var storeCartAsPreviousOrder = function (storage) {
    return function (state) {
        return function (uuid) {
            return function __do() {
                var now = nowMilliseconds();
                var previousOrder = {
                    contents: state,
                    id: uuid,
                    savedAt: new Data_Maybe.Just(Data_Newtype.unwrap()(now))
                };
                return Restaumatic_Services_Storage.setJSONItem(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                    reflectSymbol: function () {
                        return "savedAt";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.numberEncode))))({
                    reflectSymbol: function () {
                        return "id";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
                    reflectSymbol: function () {
                        return "contents";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Cart_State_State.encodeState))))(storage)(previousOrderKey)(previousOrder)();
            };
        };
    };
};
var maxPreviousOrderAge = /* #__PURE__ */ Data_Time_Duration.fromDuration(Data_Time_Duration.durationHours)(3.0);
var maxCartAge = /* #__PURE__ */ Data_Time_Duration.fromDuration(Data_Time_Duration.durationMinutes)(30.0);
var loadCartFromPreviousOrder$prime = function (storage) {
    return function (uuid) {
        return function __do() {
            var v = Restaumatic_Services_Storage.getJSONItem(Foreign_Generic_Class.recordDecode()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
                reflectSymbol: function () {
                    return "savedAt";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.numberDecode)))())({
                reflectSymbol: function () {
                    return "id";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
                reflectSymbol: function () {
                    return "contents";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Cart_State_State.decodeState))()))(storage)(previousOrderKey)();
            if (v instanceof Data_Maybe.Just && v.value0.id === uuid) {
                return new Data_Maybe.Just(v.value0.contents);
            };
            return Data_Maybe.Nothing.value;
        };
    };
};
var isNotStale = function (currentTime) {
    return function (v) {
        return Data_Ord.lessThanOrEq(Data_Time_Duration.ordMilliseconds)(currentTime)(Data_Semigroup.append(Data_Time_Duration.semigroupMilliseconds)(v.savedAt)(maxCartAge));
    };
};
var hasRecentlyOrdered = function __do() {
    var v = Restaumatic_Services_Storage.getJSONItem(Foreign_Generic_Class.recordDecode()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "savedAt";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.numberDecode)))())({
        reflectSymbol: function () {
            return "id";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "contents";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Cart_State_State.decodeState))()))(Restaumatic_Services_Storage_LocalStorageNoFallback.localStorageNoFallback)(previousOrderKey)();
    if (v instanceof Data_Maybe.Just && v.value0.savedAt instanceof Data_Maybe.Just) {
        var now = nowMilliseconds();
        return Data_Ord.lessThanOrEq(Data_Time_Duration.ordMilliseconds)(now)(Data_Semigroup.append(Data_Time_Duration.semigroupMilliseconds)(v.value0.savedAt.value0)(maxPreviousOrderAge));
    };
    return false;
};
var cartKey = "cart";
var clearCart = function (storage) {
    return Restaumatic_Services_Storage.setJSONItem(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordNil))(storage)(cartKey)({});
};
var loadCartState = function (storage) {
    return function __do() {
        var now = nowMilliseconds();
        var v = Restaumatic_Services_Storage.getJSONItem(Foreign_Generic_Class.recordDecode()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
            reflectSymbol: function () {
                return "state";
            }
        })(Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Cart_State_State.decodeState))())({
            reflectSymbol: function () {
                return "savedAt";
            }
        })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.numberDecode))()))(storage)(cartKey)();
        if (v instanceof Data_Maybe.Nothing) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Data_Maybe.Just) {
            var age = Data_Int.floor(Data_Numeric.sub(Data_Numeric.additiveNumber)(Data_Newtype.unwrap()(now))(v.value0.savedAt) / 1000.0);
            var $17 = isNotStale(now)(v.value0);
            if ($17) {
                Effect_Class_Console.log(Effect_Class.monadEffectEffect)("Cart loaded, age=" + (Data_Show.show(Data_Show.showInt)(age) + " seconds"))();
                return new Data_Maybe.Just(v.value0.state);
            };
            Effect_Class_Console.log(Effect_Class.monadEffectEffect)("Discarding stale cart, age=" + (Data_Show.show(Data_Show.showInt)(age) + " seconds"))();
            return Data_Maybe.Nothing.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Cart.Storage (line 63, column 3 - line 74, column 21): " + [ v.constructor.name ]);
    };
};
var moveCartToPreviousOrder = function (uuid) {
    return function __do() {
        var m_state = loadCartState(Restaumatic_Services_Storage_LocalStorageWithFallback.localStorageWithFallback)();
        if (m_state instanceof Data_Maybe.Just) {
            storeCartAsPreviousOrder(Restaumatic_Services_Storage_LocalStorageNoFallback.localStorageNoFallback)(m_state.value0)(uuid)();
            return clearCart(Restaumatic_Services_Storage_LocalStorageWithFallback.localStorageWithFallback)();
        };
        return Data_Unit.unit;
    };
};
var storeCartState = function (storage) {
    return function (state) {
        return function __do() {
            var now = nowMilliseconds();
            var state$prime = {
                state: state,
                savedAt: Data_Newtype.unwrap()(now)
            };
            return Restaumatic_Services_Storage.setJSONItem(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                reflectSymbol: function () {
                    return "state";
                }
            })(Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Cart_State_State.encodeState)))({
                reflectSymbol: function () {
                    return "savedAt";
                }
            })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.numberEncode))))(storage)(cartKey)(state$prime)();
        };
    };
};
var loadCartFromPreviousOrder = function (uuid) {
    return function __do() {
        var m_state = loadCartFromPreviousOrder$prime(Restaumatic_Services_Storage_LocalStorageNoFallback.localStorageNoFallback)(uuid)();
        if (m_state instanceof Data_Maybe.Just) {
            return storeCartState(Restaumatic_Services_Storage_LocalStorageWithFallback.localStorageWithFallback)(m_state.value0)();
        };
        return Data_Unit.unit;
    };
};
export {
    loadCartState,
    storeCartState,
    moveCartToPreviousOrder,
    loadCartFromPreviousOrder,
    hasRecentlyOrdered
};
//# sourceMappingURL=index.js.map
